import * as Specs from '@loadsmart/navtrac-specs/dist/models/types'
import { NullablePartial } from './tools'
import { CheckIn, CheckinStatus } from './client/checkins'
import { Conversation, Sms } from './client/conversations'
import { Location } from './client/location'

type Observation = Specs.Observation.Observation
type Gate = Specs.Gate.Gate
type Vehicle = Specs.Vehicle.Vehicle
type Chassis = Specs.Chassis.Chassis
type ChassisType = Specs.ChassisType.ChassisType
type Load = Specs.Load.Load
type Color = Specs.Color.Color
type Carrier = Specs.Carrier.Carrier
type VehicleType = Specs.VehicleType.VehicleType
type LoadType = Specs.LoadType.LoadType
type CompanyType = Specs.CompanyType.CompanyType
type User = Specs.User.User
type Site = Specs.Site.Site
type ObservationAudit = Specs.ObservationAudit.ObservationAudit
type Company = Specs.Company.Company

export type ApiObservationWDwell = Observation & {
    vehicleDwellTime?: number | null
    loadDwellTime?: number | null
    chassisDwellTime?: number | null
    imageNames?: string[]
    imagePath?: string
    imagePaths?: string[]
    id: string
}

/** COMPOSIT TYPES */
export type ApiSiteWGates = Site & {
    gates: Gate[]
    locations: Location[]
}

type ExtraLoadTypes = NullablePartial<{
    type?: LoadType | null
    color?: Color | null
    licensePlate: string
    state: string
}>

export type ApiObservationResponseItem = NullablePartial<
    ApiObservationWDwell & {
        gateId?: string | null
        gate: Gate & { site?: Site | null }
        vehicle: NullablePartial<Vehicle> & {
            type?: VehicleType | null | undefined
            color?: Color | null | undefined
            carrier?: Carrier | null | undefined
        }
        chassis: NullablePartial<Chassis & { type?: ChassisType | null; color?: Color | null }>
        load: NullablePartial<Load & ExtraLoadTypes>
        loadOutwardObservation: NullablePartial<ApiObservationWDwell>
        chassisOutwardObservation: NullablePartial<ApiObservationWDwell>
        vehicleOutwardObservation: NullablePartial<ApiObservationWDwell>
        chassisIsBare: boolean | null
        meta: { loadCustomerName?: string | null }
        tags?: string[]
    }
>

/** DIRECT TYPES */
export enum ApiPermission {
    // admin = 'admin',
    // alerts = 'alerts',
    users = 'users',
    audits = 'audits',
    checkins = 'checkins',
}

export type ApiUserMetaType = { meta: { reports: Record<string, Array<string>> } }

export type ApiUser = User & ApiUserMetaType
export type ApiUserDraft = NullablePartial<
    Omit<User, 'permissions'> & {
        permissions: ApiPermission[]
    }
>
export type ApiVehicle = Vehicle
export type ApiObservation = ApiObservationWDwell
export type ApiSite = Site
export type ApiGate = Gate
export type ApiLoad = Load & ExtraLoadTypes
export type ApiChassis = Chassis
export type ApiColor = Color
export type ApiCarrier = Carrier
export type ApiVehicleType = VehicleType
export type ApiChassisType = ChassisType
export type ApiLoadType = LoadType
export type ApiCompany = Company
export type ApiCompanyType = CompanyType
export const API_OBSERVATION_STAT_KEYS = [
    'Vehicle Tractor',
    'Load Container',
    'Load Container Reefer',
    'Load Dry Van',
    'Load Dry Van Reefer',
    'Chassis',
    'Bare Chassis',
] as const
export type ObservationStatKey = (typeof API_OBSERVATION_STAT_KEYS)[number]

export type ApiObservationAudit = ObservationAudit

export type ApiCheckin = {
    data: CheckIn[]
}

export type ApiCheckinHistory = {
    data: any
    meta: any
}

export type ApiCheckinStatus = {
    data: CheckinStatus[]
}

export type ApiCheckinUpdate = {
    data: {
        statusId: string
        siteId: string
        updatedAt: string
        id: string
        firstName: string
        lastName: string
        phoneNumber: string
        vehicleLicensePlate: string
        loadNumber: string
        carrierName: string
        securitySeal: string | null
        outgatedAt: string | null
        companyId: string | null
        fuelTypeId: string | null
        observationId: string | null
        meta: any
        createdAt: string
        company: string | null
        site: string | null
        status: CheckinStatus
    }
}

export type ApiDockOptions = {
    data: {
        id: string
        companyId: string
        siteId: string
        meta: {
            name: string
        }
        createdAt: string
        updatedAt: string
        site: any
        company: any
    }
}

export type ApiFuelTypes = {
    id: string
    name: string
    category: string
    meta: any
    createdAt: string
    updatedAt: string
}

export type ApiConversation = {
    data: Conversation
}
export type ApiSendCheckinSms = {
    data: {
        status: boolean
    }
}
export type ApiConversationSms = {
    data: Sms[]
}
